import { useState } from "react";
import { Link } from "react-router-dom";
import { Leaf, Mail, ArrowLeft } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);

    async function onSubmit(e) {
        e.preventDefault();
        setSubmitting(true);
        setError(null);
        try {
            await api.post("/auth/forgot-password", { email: email.trim() });
            setSubmitted(true);
            toast.success("Email inviata se l'account esiste");
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className="min-h-screen bg-bone grid place-items-center px-4 py-10">
            <div className="w-full max-w-md">
                <Link to="/login" className="flex items-center gap-3 mb-8 text-stone-600 hover:text-forest" data-testid="forgot-back-link">
                    <ArrowLeft size={18} /> Torna all'accesso
                </Link>

                <div className="bg-white rounded-2xl shadow-sm border border-soft p-7">
                    <div className="w-14 h-14 rounded-2xl bg-forest text-white grid place-items-center mb-5">
                        <Leaf size={28} />
                    </div>
                    <h1 className="font-display text-2xl text-forest-dark mb-1">Password dimenticata?</h1>

                    {submitted ? (
                        <p className="text-sm text-stone-600 mt-4" data-testid="forgot-success">
                            Se l'email è registrata, riceverai a breve un link per reimpostare la password.
                            Controlla anche la cartella <b>spam/promozioni</b>.
                        </p>
                    ) : (
                        <>
                            <p className="text-sm text-stone-500 mb-6">
                                Inserisci la tua email: ti invieremo un link per scegliere una nuova password.
                            </p>
                            <form onSubmit={onSubmit} className="space-y-4">
                                <label className="block">
                                    <span className="text-xs font-semibold text-stone-600 uppercase tracking-wide">Email</span>
                                    <div className="mt-1 relative">
                                        <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
                                        <input
                                            type="email"
                                            required
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            className="input pl-10"
                                            data-testid="forgot-email"
                                        />
                                    </div>
                                </label>
                                {error && <div className="text-sm text-red-700 bg-red-50 border border-red-100 rounded-lg px-3 py-2">{error}</div>}
                                <button
                                    type="submit"
                                    disabled={submitting}
                                    className="btn-primary w-full"
                                    data-testid="forgot-submit"
                                >
                                    {submitting ? "Invio in corso..." : "Invia link di recupero"}
                                </button>
                            </form>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
